import { userCacheService, userWorkspaceCacheService, userAccountCacheService } from "../services/feathers.service";

import Graph from "./cache/graph";

export async function getUserCache(id) {
  const userCacheObject = await userCacheService.get(id);
  const userCache = Graph.fromObject(userCacheObject.obj);
  return userCache
}

export async function getUserWorkspaceCache(id) {
  const userCacheObject = await userWorkspaceCacheService.get(id);
  const userCache = Graph.fromObject(userCacheObject.obj);
  return userCache
}

export async function getUserAccountCache(id) {
  const userCacheObject = await userAccountCacheService.get(id);
  const userCache = Graph.fromObject(userCacheObject.obj);
  return userCache
}